import {
  GetTimeConditionsDocument,
  UpsertTimeConditionDocument,
  UpsertTimeConditionMutationVariables,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

export const useUpsertTimeCondition = () => {
  const [upsertTimeCondition, { loading }] = useMutation(UpsertTimeConditionDocument, {
    extractorFn: (data) => data.timeBalanceMutations.upsertTimebalanceTimeCondition,
    refetchQueries: [GetTimeConditionsDocument],
  })

  return {
    loading,
    upsertTimeCondition(variables: UpsertTimeConditionMutationVariables) {
      return upsertTimeCondition({
        variables: variables,
      })
    },
  }
}
